import { InjectedStyledComponent } from '../InjectedStyledComponent';

const cssPrefix = `
	display: flex;
	justify-content: space-between;
`;

export default InjectedStyledComponent('button', 'shared', ['dropdownButton'], ['appStore'], cssPrefix);